import AppLogo from "@/components/ui/AppLogo";
import Link from "next/link";

const footerLinks = {
  company: [
    { label: "About", href: "/about-us" },
    { label: "Contact Us", href: "/contact-us" },
    { label: "Careers", href: "/contact-us" },
    { label: "Get Updates", href: "/home-page#newsletter" },
    { label: "Terms & Conditions", href: "/terms-and-conditions" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "News", href: "/news" },
    { label: "Partners", href: "/partners" }
  ],
  support: [
    { label: "Support", href: "/contact-us" },
    { label: "Blog", href: "/blog" },
    { label: "Sales", href: "/contact-us" },
    { label: "Cities", href: "/home-page#cities" },
    { label: "FAQ", href: "/faq" },
    { label: "Retailers", href: "/landing/retailers" },
    { label: "Check Application Status", href: "/check-status" }
  ]
};

const socialLinks = [
{
  href: "https://www.facebook.com/gogedit/",
  label: "Facebook",
  icon:
  <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>

},
{
  href: "https://twitter.com/GoGeditInc/",
  label: "X",
  icon:
  <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>

},
{
  href: "https://www.linkedin.com/company/gogedit/",
  label: "LinkedIn",
  icon:
  <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>

},
{
  href: "https://www.instagram.com/gogeditinc/",
  label: "Instagram",
  icon:
  <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
      </svg>

}];


export default function FooterSection() {
  return (
    <footer className="bg-deep-navy text-white" id="contact">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 gap-12 mb-16">
          {/* Brand column */}
          <div className="lg:col-span-1 space-y-6">
            <AppLogo
              size={120}
              className="brightness-0 invert" />
            
            <p className="text-white/50 text-sm leading-relaxed">
              Redefining Urban Logistics. Your buying and moving power just became almost limitless.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks?.map((s) =>
              <a
                key={s?.label}
                href={s?.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s?.label}
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-brand-purple hover:text-white transition-all">
                
                  {s?.icon}
                </a>
              )}
            </div>
          </div>

          {/* Company links */}
          <div>
            <h4 className="font-heading font-700 text-sm uppercase tracking-widest text-white/40 mb-6">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <Link
                    href={link?.href}
                    className="text-white/60 text-sm hover:text-white transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support links */}
          <div>
            <h4 className="font-heading font-700 text-sm uppercase tracking-widest text-white/40 mb-6">
              Get Support
            </h4>
            <ul className="space-y-3">
              {footerLinks?.support?.map((link) => (
                <li key={link?.label}>
                  <Link
                    href={link?.href}
                    className="text-white/60 text-sm hover:text-white transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="font-heading font-700 text-sm uppercase tracking-widest text-white/40 mb-6">
              Contact Us
            </h4>
            <div className="space-y-4">
              {[
              {
                icon:
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>,

                label: "Mon–Fri: 9 am – 5 pm"
              },
              {
                icon:
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>,

                label: "Toronto, Ontario, Canada"
              },
              {
                icon:
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>,

                label: "info@gogedit.ca",
                href: "mailto:info@gogedit.ca"
              }]?.
              map((item) =>
              <div key={item?.label} className="flex items-start gap-3">
                  <span className="text-brand-purple mt-0.5">{item?.icon}</span>
                  {item?.href ?
                <a href={item?.href} className="text-white/60 text-sm hover:text-white transition-colors">
                      {item?.label}
                    </a> :

                <span className="text-white/60 text-sm">{item?.label}</span>
                }
                </div>
              )}
            </div>

            {/* CTA in footer */}
            <div className="mt-8 p-5 rounded-2xl bg-brand-purple/20 border border-brand-purple/30">
              <p className="text-white font-bold text-sm mb-3">Ready to GoGedit?</p>
              <Link href="/be-a-user" className="btn-primary text-sm py-2.5 px-5">
                Get the App
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-sm">
            © GoGedit Inc. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link href="/privacy-policy" className="text-white/30 text-xs hover:text-white/60 transition-colors">
              Privacy Policy
            </Link>
            <Link href="/terms-and-conditions" className="text-white/30 text-xs hover:text-white/60 transition-colors">
              Terms & Conditions
            </Link>
            <span className="text-white/20 text-xs">
              Built in Toronto 🍁
            </span>
          </div>
        </div>
      </div>
    </footer>);

}